export default {
    POLYLINE: {
        COLOR: null,
        WEIGHT: 4
    }
};
